// Dev-only logging. Diagnostics stay in the code where they're useful, but the
// production console stays clean — only real errors get through.
const isDev = process.env.NODE_ENV !== "production";

export function logDebug(...args) {
  if (isDev) console.debug(...args);
}

export function logWarn(...args) {
  if (isDev) console.warn(...args);
}

export function logError(...args) {
  console.error(...args);
}
